import { useEffect, useState } from "react";
import axios from "axios";
import { LOGO_URL } from "@/lib/siteData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLeads() {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        (async () => {
            try {
                const { data } = await axios.get(`${API}/leads`);
                setLeads(data);
            } catch (e) {
                setError(e?.message || "Failed to load leads");
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div data-testid="admin-leads-page" className="min-h-screen bg-background text-foreground p-8 md:p-14 font-sans">
            <div className="max-w-6xl mx-auto">
                <div className="flex items-center gap-4 mb-10">
                    <img src={LOGO_URL} alt="logo" className="h-12 w-12 object-contain" />
                    <div>
                        <h1 className="font-display text-3xl md:text-4xl">Lead Inbox</h1>
                        <p className="text-sm text-muted-foreground">CHANDAK BuildVision — internal</p>
                    </div>
                </div>

                {loading && <p data-testid="loading" className="text-muted-foreground">Loading…</p>}
                {error && <p data-testid="error" className="text-red-500">{error}</p>}

                {!loading && !error && (
                    <div data-testid="leads-count" className="mb-6 text-sm text-muted-foreground">
                        {leads.length} total
                    </div>
                )}

                <div className="space-y-4">
                    {leads.map((l) => (
                        <div
                            key={l.id}
                            data-testid={`lead-${l.id}`}
                            className="border hairline rounded-lg p-5 bg-card"
                        >
                            <div className="flex flex-wrap items-baseline justify-between gap-2">
                                <div>
                                    <div className="font-display text-xl">{l.name}</div>
                                    <div className="text-sm text-muted-foreground">
                                        {l.email} · {l.phone}
                                    </div>
                                </div>
                                <div className="text-xs text-muted-foreground">
                                    {new Date(l.created_at).toLocaleString()}
                                </div>
                            </div>
                            <div className="mt-3 grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                                {l.project_type && (
                                    <div>
                                        <span className="text-muted-foreground">Project · </span>
                                        {l.project_type}
                                    </div>
                                )}
                                {l.budget && (
                                    <div>
                                        <span className="text-muted-foreground">Budget · </span>
                                        {l.budget}
                                    </div>
                                )}
                                {l.location && (
                                    <div>
                                        <span className="text-muted-foreground">Location · </span>
                                        {l.location}
                                    </div>
                                )}
                            </div>
                            {l.message && (
                                <p className="mt-3 text-sm whitespace-pre-wrap">{l.message}</p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
